import { type SanityContentCarouselBlock } from '@data/sanity/queries/types/blocks'

import Carousel, { type CarouselProps } from '@components/carousel'
import ContentCarouselItem from './content-carousel-item'

type ContentCarouselProps = Pick<
  SanityContentCarouselBlock,
  'title' | 'items' | 'spacing'
> &
  Pick<CarouselProps, 'hasContainer'>

const ContentCarousel = ({
  title,
  items,
  spacing,
  hasContainer,
}: ContentCarouselProps) => (
  <Carousel
    title={title}
    items={items?.map((item) => (
      <ContentCarouselItem key={item._key} item={item} />
    ))}
    spacing={spacing}
    hasArrows
    hasContainer={hasContainer}
  />
)

export default ContentCarousel
